import { setIsTemplateDropdownModalOpen } from '@common-reducers/CampaignReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import TemplatePicker from './template-picker';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/common/components/dialog';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';



export default function MessageEditorTemplateDropdown() {
  const { t, i18n } = useTranslation(namespace);
  const dispatch = useAppDispatch()
  const isRtl = i18n.dir(i18n.language) === 'rtl';

  const isTemplateDropdownModalOpen = useAppSelector((state) => state.CampaignReducer.isTemplateDropdownModalOpen)

  const handleOpenBulkTemplateDialog = () => {
    dispatch(setIsTemplateDropdownModalOpen(true));
  };

  const handleCloseBulkTemplateDialog = () => {
    dispatch(setIsTemplateDropdownModalOpen(false));
  };

  return (
    <>
      <Button
        onClick={handleOpenBulkTemplateDialog}
        // Secondary treatment. The drop shadow, the hover lift and the press
        // depression are what a PRIMARY button does — they were making a
        // shortcut read as the main event, sitting a few inches from Schedule
        // Send. What is left is a flat tinted pill that still looks pressable:
        // a border, a hover that deepens rather than lifts, and a focus ring.
        className={cn(
          "rounded-[20px] font-medium text-[13px] px-4 py-2",
          "border transition-colors duration-150",
          "hover:brightness-[0.97] active:brightness-[0.94]",
        )}
        style={{
          // Its own token rather than --fab-bg: --fab-bg is the PRIMARY brand
          // gradient and is still exactly that everywhere it is used (the two
          // FABs, the bulk dashboard button, Quick Agents). This token is the
          // secondary step of the same family, and the clear flow re-points the
          // trio together.
          background: "var(--template-cta-bg)",
          color: "var(--template-cta-text)",
          borderColor: "var(--template-cta-border)",
          marginInlineEnd: '5px',
        }}
      >
        {t('messageEditor.templates')}
      </Button>
      <Dialog open={isTemplateDropdownModalOpen} onOpenChange={(open) => {
        if (!open) {
          handleCloseBulkTemplateDialog();
        }
      }}>
        <DialogContent
          dir={isRtl ? 'rtl' : 'ltr'}
          className="max-w-[900px] w-[95vw] p-0 flex flex-col h-[85vh] max-h-[800px]"
        >
          <DialogHeader className="px-8 pt-6 pb-2 flex-shrink-0 text-start sm:text-start">
            <DialogTitle className="text-xl font-semibold text-slate-800 dark:text-slate-100">
              {t('messageEditor.selectTemplate')}
            </DialogTitle>
            <DialogDescription className="sr-only">
              {t('messageEditor.chooseTemplate')}
            </DialogDescription>
          </DialogHeader>
          <div className="px-8 pb-6 flex-1 min-h-0 overflow-hidden">
            <TemplatePicker onClose={handleCloseBulkTemplateDialog} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
